

  // for build



import axios from 'axios';

const NODE_URL = process.env.REACT_APP_NODE_URL ;

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;



export const api = axios.create({
  baseURL: NODE_URL,
  headers: {
    'Content-Type': 'application/json',
    'x-secret-key': SECRET_KEY,
  }
});




